export default "__VITE_ASSET__CWrM7L20__"